export class DashboardStats {
  messagesNo: number;
  weekStats: ChartDataMulti[];

  constructor() {
    this.messagesNo = 0;
    this.weekStats = [];
  }
}

export class ChartData {
  name: string;
  value: number;

  constructor() {
    this.name = '';
    this.value = 0;
  }
}

export class ChartDataMulti {
  name: string;
  series: ChartData[];

  constructor() {
    this.name = '';
    this.series = [];
  }
}
